module.exports = __webpack_public_path__ + "img/word.71979a7f.svg";